<template>
  <Layout>
    <div class="section">
      <div class="container" style="max-width: 1160px">
        <div class="section--header">
          <h2 class="section--title">最近新闻</h2>
          <p class="section--description">
            峦璞再生资源完成独立成立新一代可回收物资，引领者采用AI,物联网,智能设备用于减少环境污染，使用AI视觉技术提高数据分析手段，无需样品邮寄实验室化验，也可72小时内估算园区有色金属含量等估值信息。
            <br>为废旧园区/工厂提供更高效的智慧时代解决方案
          </p>
        </div>

        <div class="news-contaier">
          <!-- 新闻列表 -->
          <div class="news-grid">
            <div
                v-for="(article, index) in currentArticles"
                :key="index"
                class="news-card"
            >
              <h3>{{ article.title }}</h3>
              <p class="date">{{ article.date }}</p>
              <p class="content">{{ article.content }}</p>
            </div>
          </div>

          <!-- 分页 -->
          <div class="blog">
            <ul class="am-pagination" style="text-align: center;">
              <li :class="pageIndex === 1 ? 'am-disabled':''"
                  @click="changeIndex(pageIndex - 1)">
                <a href="#">&laquo;</a>
              </li>
              <li v-for="p in totalPages"
                  :key="p"
                  @click="changeIndex(p)"
                  :class="pageIndex === p ? 'am-active':''">
                <a href="#">{{ p }}</a>
              </li>
              <li :class="pageIndex === totalPages ? 'am-disabled':''"
                  @click="changeIndex(pageIndex + 1)">
                <a href="#">&raquo;</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/common/Layout";
export default {
  name: "NewsView",
  components: {Layout},
  data(){
    return{
      pageIndex: 1,
      pageSize: 4, // 每页显示4条
      // 静态数据
      articles: [
        {
          "title": "智能拆解技术研讨会",
          "date": "2025-03-10",
          "content": "我们成功举办了首届智能拆解技术国际论坛，与会专家分享了最新的环保拆解解决方案，推动了行业的技术进步。"
        },
        {
          "title": "工业互联网平台上线",
          "date": "2025-01-12",
          "content": "我们自主研发的工业互联网平台正式投入使用，显著提升了生产效率和管理水平。"
        },
        {
          "title": "天津二七康库得曲轴有限公司",
          "date": "2024-10-23",
          "content": "原天津二七康库得曲轴制造园区的3000万元资产收购，实现工业固废资源化率超95%,废旧机器利用率达90%，环保表现达到97%。"
        },
        {
          "title": "莘县信泽科技有限公司",
          "date": "2024-03-11",
          "content": "通过6300万元资产收购获得莘县信泽科技产业园完整产权，拆除原有化工设施后，聚焦工业拆解、废弃物再生等高附加值环节，响应国家“双碳”目标及循环经济政策。"
        },
        {
          "title": "山东宁威新能源科技有限公司",
          "date": "2023-03-18",
          "content": "我们成功并购了山东宁威新能源科技有限公司，交易金额为2300万元。"
        },
        {
          "title": "建滔天然气化工(重庆)有限公司",
          "date": "2020-9-20",
          "content": "投资1826万元完成对建滔天然气化工（重庆）园区的产权交割，该化工园区拆除工程将采用自主研发的危化品处理机器人集群，实现17类有毒残留物的无害化处理。"
        },
        ]
    }
  },
  computed: {
    // 总页数
    totalPages() {
      return Math.ceil(this.articles.length / this.pageSize)
    },
    // 当前页数据
    currentArticles() {
      const start = (this.pageIndex - 1) * this.pageSize
      return this.articles.slice(start, start + this.pageSize)
    }
  },
  methods:{
    changeIndex(p){
      if (p < 1) p = 1
      if (p > this.totalPages) p = this.totalPages
      this.pageIndex = p
    }
  }
}
</script>

<style scoped>
/* 新闻网格布局 */
.news-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin: 40px 0;
}

.news-card {
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  transition: transform 0.3s ease;
}

.news-card:hover {
  transform: translateY(-5px);
}

.news-card h3 {
  color: #1a365d;
  font-size: 1.3rem;
  margin-bottom: 12px;
}

.news-card .date {
  color: #718096;
  font-size: 0.9rem;
  margin-bottom: 15px;
}

.news-card .content {
  color: #4a5568;
  line-height: 1.6;
}

/* 分页样式 */
.am-pagination {
  margin-top: 40px;
}

.am-pagination > li > a {
  border-radius: 8px !important;
  margin: 0 5px;
  transition: all 0.3s ease;
}

.am-pagination > .am-active > a {
  background: #2563eb;
  border-color: #2563eb;
  color: white !important;
}

/* 响应式 */
@media (max-width: 768px) {
  .news-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .news-card {
    padding: 20px;
  }
}
</style>